import { render, staticRenderFns } from "./OutpatientCare.vue?vue&type=template&id=18151f28&scoped=true&"
import script from "./OutpatientCare.vue?vue&type=script&lang=js&"
export * from "./OutpatientCare.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientCare.vue?vue&type=style&index=0&id=18151f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18151f28",
  null
  
)

export default component.exports